export { default } from './SectionHeader.jsx';